import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

function resolveBackendUrl(url) {
  if (!url || /^https?:\/\//i.test(url)) {
    return url;
  }

  return `${BACKEND_URL}${url.startsWith('/') ? url : `/${url}`}`;
}

export async function getLoginAnnouncements() {
  const response = await axios.get(`${BACKEND_URL}/api/announcements`);
  const announcements = response.data?.announcements;

  if (!Array.isArray(announcements)) {
    return [];
  }

  return announcements.map((announcement) => ({
    ...announcement,
    thumbnailUrl: resolveBackendUrl(announcement.thumbnailUrl),
    pdfUrl: resolveBackendUrl(announcement.pdfUrl),
  }));
}

export { resolveBackendUrl };
